export const ASSETS = {
    logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_shikha-dentistry/artifacts/m97wgm63_WhatsApp_Image_2026-07-19_at_16.36.11-removebg-preview.png",
    banner: "https://customer-assets-v7afamib.emergentagent.net/job_562ca78a-4d62-487c-acdd-edb6dffb800b/artifacts/9hjvggxm_WhatsApp%20Image%202026-07-19%20at%2016.35.18.jpeg",
    chair: "https://customer-assets-v7afamib.emergentagent.net/job_562ca78a-4d62-487c-acdd-edb6dffb800b/artifacts/n5wnyobw_WhatsApp%20Image%202026-07-18%20at%2019.57.57%20%281%29.jpeg",
    doctor: "https://customer-assets-v7afamib.emergentagent.net/job_562ca78a-4d62-487c-acdd-edb6dffb800b/artifacts/d2v9mh5p_WhatsApp%20Image%202026-07-19%20at%2012.15.35.jpeg",
    operatory: "https://customer-assets-v7afamib.emergentagent.net/job_562ca78a-4d62-487c-acdd-edb6dffb800b/artifacts/jbxel8em_WhatsApp%20Image%202026-07-18%20at%2020.40.42%20%281%29.jpeg",
};

export const CLINIC = {
    name: "Surya Dental Care",
    doctor: "Dr. Shikha Sinha",
    creds: "BDS, MDS",
    specialty: "Periodontology & Oral Implantology",
    phone: "9304530283",
    phoneE164: "+919304530283",
    whatsapp: "https://wa.me/919304530283",
    address: "Tirkey Complex, opposite Tata Motors, Dibdih, Ranchi",
    addressLine2: "Jharkhand 834002, India",
    city: "Ranchi",
    state: "Jharkhand",
    pincode: "834002",
    plusCode: "88P3+Q6 Ranchi, Jharkhand",
    mapsLink: "https://maps.app.goo.gl/HkmmhZ77c81oDuAN7",
    mapsEmbed:
        "https://www.google.com/maps?q=Surya+Dental+Care+Dr+Shikha+Sinha+Tirkey+Complex+Dibdih+Ranchi+834002&output=embed",
    hours: {
        weekdays: "Mon — Sat · 2:00 PM – 8:00 PM",
        sunday: "Sunday · 10:00 AM – 1:00 PM",
    },
    stats: [
        { value: "'16", label: "BDS · 2012 – 2016" },
        { value: "'23", label: "MDS · Periodontology, 2020 – 2023" },
        { value: "DRH", label: "CMP Dental Surgeon · Divisional Railway Hospital, Hatia — Nov 2024" },
        { value: "7", label: "Days a week, incl. Sunday" },
    ],
    timeline: [
        {
            year: "2012 — 2016",
            title: "BDS",
            body: "Bachelor of Dental Surgery — foundational years of clinical training.",
        },
        {
            year: "2020 — 2023",
            title: "MDS",
            body: "Master of Dental Surgery — specialisation in Periodontology & Oral Implantology.",
        },
        {
            year: "Nov 2024 — Present",
            title: "CMP — Dental Surgeon",
            body: "Contract Medical Practitioner (Dental Surgeon) at the Divisional Railway Hospital, Hatia, alongside private practice at Surya Dental Care.",
        },
    ],
    testimonials: [
        {
            quote: "Dr. Shikha explained every step. My gum treatment was painless and my confidence back within a week.",
            author: "Anjali M.",
            place: "Kanke, Ranchi",
            treatment: "Periodontal therapy",
        },
        {
            quote: "Best implant experience in the city — precise, calm, and the follow-up care was exceptional.",
            author: "Rakesh S.",
            place: "Doranda, Ranchi",
            treatment: "Single-tooth implant",
        },
        {
            quote: "She works with children so patiently. My daughter now asks when the next dentist visit is.",
            author: "Priya R.",
            place: "Lalpur, Ranchi",
            treatment: "Paediatric dentistry",
        },
    ],
    careFlow: [
        {
            step: "01",
            title: "Consult",
            body: "A calm conversation. We understand history, habits, and concerns before touching a tool.",
        },
        {
            step: "02",
            title: "Diagnose",
            body: "Digital imaging, periodontal charting, evidence-based plan — shared with you in plain language.",
        },
        {
            step: "03",
            title: "Treat",
            body: "Precision procedures with modern equipment, strict sterilisation, and post-care that actually follows through.",
        },
    ],
};
